import { render, staticRenderFns } from "./ReportModal.vue?vue&type=template&id=20d00a70&scoped=true&"
import script from "./ReportModal.vue?vue&type=script&lang=js&"
export * from "./ReportModal.vue?vue&type=script&lang=js&"
import style0 from "./ReportModal.vue?vue&type=style&index=0&id=20d00a70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d00a70",
  null
  
)

export default component.exports